// extracted by mini-css-extract-plugin
module.exports = {"roomsListLayout":"RoomsList_roomsListLayout__3DMEW","menu":"RoomsList_menu__1a0cA","searchInput":"RoomsList_searchInput__2s3jQ","chooseDropdown":"RoomsList_chooseDropdown__39EDH"};